<template>
<div class="chapter">
<div class="inner_page">
<p class="cr mtop">© 2023 by Christopher Berry-Dee</p>
<p class="cr mtop">All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p class="cr mtop">First published in Great Britain by John Blake Publishing, an imprint of Bonnier Books</p>
<p class="cr">For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a></p>
<p class="cr mtop">Diversion Books</p>
<p class="cr">A division of Diversion Publishing Corp.</p>
<p class="cr"><a href="http://www.diversionbooks.com/" target="_blank">www.diversionbooks.com</a></p>
<p class="cr mtop">First Diversion Books Edition: August 2023</p>
<p class="cr">eBook ISBN: 9781635768572</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// f004.vue?49d107a9